export default "__VITE_ASSET__KkesyZvi__"